<ngx-datatable
    #myTable
    [messages]="helper.ngxDataTableTransletedMessages"
    [rows]="allTasks | async"
    [columnMode]="'force'"
    [rowHeight]="'auto'"
    [limit]="itemsPerPage"
    [footerHeight]="'auto'"
    [selectionType]="'single'"
    [offset]="currentPage - 1"
    (select)="onSelect($event)"
    (activate)="onActive($event)"
    class="material mf-custom-pagination mf-index-task"
>
    <ngx-datatable-column [width]="30" [canAutoResize]="false" [sortable]="false" name="" prop="status" i18n-name>
        <ng-template let-row="row" ngx-datatable-cell-template let-value="value ">
            <label class="m-checkbox m-checkbox--solid m-checkbox--single m-checkbox--brand mt-1">
                <input [checked]="value == 2" (click)="concludeTask(row, $event); $event.stopPropagation()" type="checkbox" class="mf-t-itCheckbox" />
                <span></span>
            </label>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [maxWidth]="400" [sortable]="false" name="Naziv" prop="description" i18n-name="@@48ce083d5eff1560cedc937f4cd940bc4b6bbc77">
        <ng-template ngx-datatable-cell-template let-value="value" let-row="row">
            {{ value }}
            <div *ngIf="row.customerName">
                <small>
                    <i class="la la-user"></i>
                    {{ row.customerName }}
                </small>
            </div>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [maxWidth]="150" [canAutoResize]="true" name="Rok" prop="dueDate" i18n-name="@@edc1e592572a39f30d1c28e4e717a2ef5cb0a014">
        <ng-template ngx-datatable-cell-template let-value="value">
            {{ value | date: 'dd.MM.yyyy' }}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
        [maxWidth]="100"
        [canAutoResize]="true"
        name="Odgovoren"
        prop="delegatedName"
        i18n-name="@@d0e08a6a3a5226f2984e057ac0472b4f1540bbca"
    >
        <ng-template ngx-datatable-cell-template let-value="value">
            <small>
                {{ value }}
            </small>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-footer>
        <!-- https://stackoverflow.com/questions/46337403/how-to-add-pagination-and-footer-template-in-ngx-datatable-->
        <ng-template
            ngx-datatable-footer-template
            let-rowCount="rowCount"
            let-pageSize="pageSize"
            let-selectedCount="selectedCount"
            let-curPage="curPage"
            let-offset="offset"
            let-isVisible="isVisible"
        >
            <ngb-pagination
                [(page)]="currentPage"
                [collectionSize]="rowCount"
                [pageSize]="itemsPerPage"
                [directionLinks]="false"
                [maxSize]="8"
                class="mx-auto"
            ></ngb-pagination>
        </ng-template>
    </ngx-datatable-footer>
</ngx-datatable>
